//client/src/lib/supabaseClient.ts
import { createClient } from "@supabase/supabase-js";

const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL ||
  "https://oxknymbqlujijdseiowv.supabase.co";
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im94a255bWJxbHVqaWpkc2Vpb3d2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk2Nzk1NzksImV4cCI6MjA2NTI1NTU3OX0.bCZtS9sb3IxlUhjuZfT71J2i8ziQsb7o8s9b6HAdhOc";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: "sb-oxknymbqlujijdseiowv-auth-token",
    redirectTo: window.location.origin,
  },
  global: {
    fetch: (url, options = {}) => {
      return fetch(url, {
        ...options,
        signal: AbortSignal.timeout(10000),
      });
    },
  },
  db: {
    schema: "public",
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey);
